import { render } from "./SessionDetailComponent.vue?vue&type=template&id=a7b03aca&ts=true"
import script from "./SessionDetailComponent.vue?vue&type=script&lang=ts"
export * from "./SessionDetailComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__